// extracted by mini-css-extract-plugin
module.exports = {"search":"style_search__1Zx1z","page-header__actions":"style_page-header__actions__3dUOS"};